import React from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';
import { publicRoutes } from 'configs/RoutesConfig';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
// import { util } from 'utils/utilsIpcall';

const Routes = () => {
	return (
		<RouterRoutes>
			<Route path="/" element={<PublicRoute />}>
				{publicRoutes.map(route => {
					return (
						<Route
							key={route.path}
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key}
									component={route.component}
									{...route.meta}
								/>
							}
						/>
					)
				})}
			</Route>
		</RouterRoutes>
	)
}


export default Routes;